export var TimeZone;
(function (TimeZone) {
    TimeZone["UTC"] = "UTC";
    // 'Local' = 'Local', // TODO: decide what to do with local option UX
    TimeZone["Pacific/Pago_Pago"] = "Pacific/Pago_Pago";
    TimeZone["Pacific/Honolulu"] = "Pacific/Honolulu";
    TimeZone["America/Anchorage"] = "America/Anchorage";
    TimeZone["America/Los_Angeles"] = "America/Los_Angeles";
    TimeZone["America/Denver"] = "America/Denver";
    TimeZone["America/Chicago"] = "America/Chicago";
    TimeZone["America/New_York"] = "America/New_York";
    TimeZone["America/Santo_Domingo"] = "America/Santo_Domingo";
    TimeZone["America/Buenos_Aires"] = "America/Buenos_Aires";
    TimeZone["America/Noronha"] = "America/Noronha";
    TimeZone["Atlantic/Cape_Verde"] = "Atlantic/Cape_Verde";
    TimeZone["Europe/Paris"] = "Europe/Paris";
    TimeZone["Europe/Athens"] = "Europe/Athens";
    TimeZone["Europe/Moscow"] = "Europe/Moscow";
    TimeZone["Europe/London"] = "Europe/London";
    TimeZone["Asia/Dubai"] = "Asia/Dubai";
    TimeZone["Asia/Karachi"] = "Asia/Karachi";
    TimeZone["Asia/Dhaka"] = "Asia/Dhaka";
    TimeZone["Asia/Bangkok"] = "Asia/Bangkok";
    TimeZone["Asia/Shanghai"] = "Asia/Shanghai";
    TimeZone["Asia/Tokyo"] = "Asia/Tokyo";
    TimeZone["Australia/Brisbane"] = "Australia/Brisbane";
    TimeZone["Australia/Sydney"] = "Australia/Sydney";
    TimeZone["Pacific/Noumea"] = "Pacific/Noumea";
    TimeZone["Pacific/Auckland"] = "Pacific/Auckland";
    TimeZone["Pacific/Apia"] = "Pacific/Apia";
    TimeZone["Pacific/Kiritimati"] = "Pacific/Kiritimati";
})(TimeZone || (TimeZone = {}));
export const isTimeZone = (timezone) => Object.values(TimeZone).includes(timezone);
//# sourceMappingURL=timezone.js.map